import CnLayoutPagePrototypeView from "./cn-layout-page/prototypeView";
import CnLayoutCellPrototypeView from "./cn-layout-cell/prototypeView";
import CnLayoutHeaderPrototypeView from "./cn-layout-header/prototypeView";
import CnLayoutFooterPrototypeView from "./cn-layout-footer/prototypeView";
import CnLayoutContentPrototypeView from "./cn-layout-content/prototypeView";
import CnLayoutSectionPrototypeView from "./cn-layout-section/prototypeView";
import CnLayoutRowPrototypeView from "./cn-layout-row/prototypeView";
import CnLayoutColPrototypeView from "./cn-layout-col/prototypeView";
import CnLayoutAsidePrototypeView from "./cn-layout-aside/prototypeView";
import CnLayoutBlockPrototypeView from "./cn-layout-block/prototypeView";
import "./prototypeView.scss";
var bundle = [CnLayoutPagePrototypeView, CnLayoutCellPrototypeView, CnLayoutHeaderPrototypeView, CnLayoutFooterPrototypeView, CnLayoutContentPrototypeView, CnLayoutSectionPrototypeView, CnLayoutRowPrototypeView, CnLayoutColPrototypeView, CnLayoutAsidePrototypeView, CnLayoutBlockPrototypeView];
export default bundle;